import { render, staticRenderFns } from "./ItemApp.vue?vue&type=template&id=ae72d126&scoped=true"
import script from "./ItemApp.vue?vue&type=script&lang=js"
export * from "./ItemApp.vue?vue&type=script&lang=js"
import style0 from "./ItemApp.vue?vue&type=style&index=0&id=ae72d126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae72d126",
  null
  
)

export default component.exports